/*
 * Jira Ticket:
 * Created Date: Fri, 21st Jan 2022, 17:19:27 pm
 * Author: Rafiul Ansari
 * Email: raf.ansari@thedistance.co.uk
 * Copyright (c) 2022 The Distance
 */

import { fetchStart, fetchEnd } from 'react-admin';

export default function getOrganisationInfo(
  id,
  {
    dataProvider,
    dispatch,
    notify,
    setOrganisationName,
    setOrganisationCapabilities,
  }
) {
  return () => {
    let isSubscribed = true;
    if (id) {
      dispatch(fetchStart());
      dataProvider('GET_ONE', 'Organisation', { id })
        .then(result => {
          if (isSubscribed) {
            if (setOrganisationName) {
              setOrganisationName(result.data?.name);
            }
            if (setOrganisationCapabilities) {
              setOrganisationCapabilities(
                result.data?.subscription?.subscriptionTier?.capabilitiesIds ||
                  []
              );
            }
          }
        })
        .catch(error => {
          const {
            extensions: { code },
            message,
          } = error.graphQLErrors[0];
          if (code !== 'INTERNAL_SERVER_ERROR') {
            notify(message, 'warning');
          }
          notify('error.organisation.unableToGetInformation', 'warning');
        })
        .finally(() => {
          dispatch(fetchEnd());
        });
    }

    return () => (isSubscribed = false);
  };
}
